import InnerComponent from '@Components/Admin/AdminConfiguration';
import orgContainer from '@Components/AppContainer';

const AdminConfiguration = () => ((orgContainer(InnerComponent)));
export default AdminConfiguration;
